// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__3mjWU","disappear":"Alert_disappear__70nkw","fadeOut":"Alert_fadeOut__3Uble","content":"Alert_content__W0gz+","closebutton":"Alert_closebutton__C25YC"};